import { CommodityTypeEnum } from "../enums";
import { FilterItem, FilterItemPascal } from "../filterItem";
import { SerializedFile } from "../serializedFile";
import { IncidentStatus, RepIncident } from "./repIncident";

export interface Complaint extends RepIncident {
	complaintId: number;
	complaintOrIncident: ComplaintOrIncident;
	complaintOrIncidentId: ComplaintOrIncident;
	complaintOrIncidentString: string;

	customerAccountNumber: string;

	complaintTypeId: number;
	complaintTypeName: string;
	complaintTypeDescription: string;
	complaintTypeOther: string;
	otherComplaintType: string;
	complaintTypeLevel: number;

	complaintSourceId: number;
	complaintSourceName: string;
	complaintSourceDescription: string;
	complaintSourceOther: string;
	otherComplaintSource: string;

	enrollmentSourceId?: number;
	enrollmentSourceName?: string;

	synopsis: string;
	utilityId: number;
	utilityName: string;
	commissionComplaint: boolean;
	ope?: boolean;
	complaintActionTakenDescription: string;
	fyiOnly: boolean;
	doNotKnock: boolean;

	complaintFYIReasonId: number;
	pucNumber: string;
	submittedBy: string;

	reportingTagId?: number;
	reportingTagName?: string;

	locationPartnerId?: number;
	locationPartnerName?: string;

	affiliatePartnerId?: number;
	affiliatePartnerName?: string;

	manualBrandId: number;
	manualBrandName: string;
	telesalesBrandId: string;
	telesalesBrandName: string;
	gridBrand: string;

	manualAgentName: string;
	manualAgentId: string;

	managerId?: number;

	language?: LanguageEnum;
	languageId?: number;
	documentsToDelete: string;
	commodity?: CommodityTypeEnum;
	commodityId?: number;
	commodityName?: string;
	staffingPartnerId?: number;
	stateId?: number;
	enrollmentValidationErrorId?: number;
	rootCauseId?: number;
	rootCauseName?: string;

	hasSurvey: boolean;
	surveyCode: string;

	representativeManagerName: string;
	courseName: string;

	// UI only
	assignedRepId?: number;
	assignedAnalystId?: number;
	attachedEnrollmentId?: number;
	documents?: SerializedFile[];
	documentsChanged?: boolean;
	qaCoachingDetail: string;
	investigationFindings: string;
}

export enum ComplaintOrIncident {
	Complaint = 0,
	Incident = 1,
	CustomerInquiry = 2,
	QualityReview = 3,
}

export enum LanguageEnum {
	English = 0,
	Spanish = 1,
}

export interface ComplaintCustomerAction {
	id: number;
	incidentId: number;
	actionTakenCategory: string;
	actionTakenCategoryId: number;
	actionTakenCategoryName: string;
	actionTakenSubCategory: string;
	actionTakenSubCategoryId?: number;
	actionTakenSubCategoryName?: string;
	actionTakenCategoryOther: string;
	count: number;
	status: IncidentStatus;
	statusId: number;
	statusName: string;
	notes: string;
	createdOn: Date;
}

export interface ComplaintUtility extends FilterItemPascal {
	AccountNumberPrefix: string;
}

/** An Online Affiliates partner for one brand; BrandId matches the complaint's Entry Brand (manualBrandId) */
export interface ComplaintAffiliatePartner extends FilterItemPascal {
	BrandId: number;
}

/** A Root Cause; the Root Cause dropdown offers it on incidents whose reportingTagId is in reportingTagIds */
export interface ComplaintRootCause extends FilterItem {
	reportingTagIds: number[];
}
